<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold secondary--text">Downline Premium</div>
		</div>
		<div class="mt-2">
			<div class="d-flex flex-wrap justify-space-between">
				<v-col cols="12" sm="4" md="3" lg="2" class="px-0">
					<v-autocomplete
						placeholder="Pilih Kode Mitra"
						outlined
						dense
						background-color="white"
						class="rounded-xl date-no-border"
						no-data-text="Tidak ada data"
						color="primary"
						hide-details="auto"
						:items="cloneList"
						item-text="network_code"
						item-value="network_code"
						v-model="search.network_code"
						@change="getData()">
					</v-autocomplete>
				</v-col>
				<v-col cols="12" sm="4" md="3" class="px-0 pb-0 pb-sm-3">
					<div class="d-flex justify-end">
						<v-btn depressed color="grey lighten-1" class="mr-2 white--text rounded-xl text-capitalize" @click="reset">Reset</v-btn>
						<v-btn depressed color="primary" class="white--text rounded-xl text-capitalize" @click="showSearch">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Cari</div>
							</div>
						</v-btn>
					</div>
				</v-col>
			</div>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="mt-3" v-if="!loading">
					<v-row v-if="downlineList.length > 0">
						<v-col cols="12" class="pt-0">
							<v-data-table hide-default-footer disable-sort :headers="table_headers" :items="downlineList" :items-per-page="limit" item-key="network_id" class="table-vo table-w-sm-120">
								<template v-slot:[`item.email`]="{ item }">
									{{ item.email | emptyData }}
								</template>
								<template v-slot:[`item.join_date`]="{ item }">
									{{ item.join_date | toDate }}
								</template>
								<template v-slot:[`item.position`]="{ item }">	
									<v-icon small color="primary">{{ item.position == 'L' ? 'mdi-arrow-left' : 'mdi-arrow-right' }}</v-icon>
									<span class="text-capitalize ml-2">{{ item.position  == 'L' ? 'Kiri' : 'Kanan' }}</span>
								</template>
								<template v-slot:[`item.level`]="{ item }">
									<v-avatar color="grey" size="32">
										<span class="white--text text-h7 font-weight-bold">{{ item.level }}</span>
									</v-avatar>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
					<div class="mt-3" v-if="downlineList.length == 0">
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
									<NoData></NoData>
									<div class="px-3 pt-3 text-center secondary--text">Tidak ada data downline yang dapat ditampilkan</div>
								</v-card>
							</v-col>
						</v-row>
					</div>
					<div v-if="downlineList.length > 0">
						<v-row justify="end">
							<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
								<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="downlinePagination.total_page" @input="changePage"></v-pagination>
							</v-col>
							<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
								<div class=" font-size-10">Menampilkan {{ downlinePagination.total_display }} data dari total {{ downlinePagination.total_data }} data</div>
							</v-col>
							<v-col cols="3" sm="2" md="1">
								<v-select :items="list_limit" v-model="limit" hide-details dense class="" placeholder="Data" item-color="red darken-3" color="primary" @input="changeLimit"></v-select>
							</v-col>
						</v-row>
					</div>
				</div>
			</v-scroll-x-reverse-transition>
			<div class="mt-3" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadData :loading="loading"></LoadData>
					</v-col>
				</v-row>
			</div>
		</div>
		<ModalCari ref="modalCari" @action="cari"></ModalCari>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalCari from './components/ModalCari';

export default {
	components: {
		ModalCari
	},
	data() {
		return {
			loading: false,
			page: 1,
			limit: '10',
			list_limit: [ '10', '20', '50', '100' ],
			search: {
				network_code: '',
			},
			params: [],
			table_headers: [
				{ text: 'Nama Mitra', width: '20%', align: 'start', value: 'name' },
				{ text: 'Kode Mitra', width: '20%', align: 'start', value: 'network_code' },
				{ text: 'Email', width: '20%', align: 'start', value: 'email' },
				{ text: 'Tgl. Pendaftaran', width: '20%', align: 'start', value: 'join_date' },
				{ text: 'Posisi', width: '10%', align: 'center', value: 'position' },
				{ text: 'Level', width: '10%', align: 'center', value: 'level' },
			]
		}
	},
	computed: {
		...mapState('jaringan', ['downlineList', 'downlinePagination']),
		...mapState('opsi', ['cloneList']),
	},
	methods: {
		...mapActions('jaringan', ['getDownlineList']),
		...mapActions('opsi', ['getCloneList']),

		showSearch() {
			this.$refs.modalCari.modalShow()
		},
		cari(data) {
			this.params = []
			this.page = 1

			if(data.name.value)
				this.params.push(data.name)

			if(data.code.value)
				this.params.push(data.code)

			if(data.email.value)
				this.params.push(data.email)

			if(data.position.value)
				this.params.push(data.position)

			if(data.date.value)
				this.params.push(data.date)

			if(data.level.value)
				this.params.push(data.level)

			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		reset() {
			this.params = []
			this.page = 1
			this.limit = '10'
			this.getData()
			this.$refs.modalCari.reset()
		},
		getData() {
			this.loading = true
			this.getDownlineList(this.queryString({ network_code: this.search.network_code, plan: 'premium', sort: 'join_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params })).then(() => {
				this.$refs.modalCari.modalHide()
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
				this.loading = false
			})
		}
	},
	async created() {
		this.$store.dispatch('setPageTitle', `Downline Premium`)
		await this.getCloneList({ plan: 'premium' })
		this.getData()
	}
};
</script>

